import Button from "components/Button/Button";
import Card from "components/Card/Card";
import KaboodleModal from "components/Modals/KaboodleModal";
import type { NoteType } from "types/DataTypes";

interface DeleteNoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  note: NoteType | null;
  isDeleting?: boolean;
}

const DeleteNoteModal = ({
  isOpen,
  onClose,
  onConfirm,
  note,
  isDeleting = false,
}: DeleteNoteModalProps) => {
  if (!note) return null;

  const notePreview =
    note.text.length > 50 ? `${note.text.substring(0, 50)}...` : note.text;

  return (
    <KaboodleModal
      isOpen={isOpen}
      onClose={onClose}
      footer={
        <div className="flex jc-c">
          <Button className="delete" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Deleting..." : "Confirm Delete"}
          </Button>
          <Button onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
        </div>
      }
    >
      <Card heading="Delete Note">
        <p>Are you sure you want to delete this note?</p>
        <div className="note-preview">"{notePreview}"</div>
        <p>This action cannot be undone.</p>
      </Card>
    </KaboodleModal>
  );
};

export default DeleteNoteModal;
